import { client } from "../../shared/services/client";
import { AxiosResponse } from 'axios'
import { MailMergeRequest } from "../model/MailMergeRequest";

const mailMergeBaseKey: string = "mailMerge";


class MailMergeAPI {
    public fetchListOfMailMergeGroup = async () => {
        client.setBaseURLForService(mailMergeBaseKey)
        const res: AxiosResponse<any> = await client.get(`/api/MailMerge/GetAllMergeDoc`);
        return res.data;
    }

    public getMergeDocument = async (request: MailMergeRequest): Promise<Blob> => {
        client.setBaseURLForService(mailMergeBaseKey)
        var blob;
        const res: AxiosResponse<Blob> = await client.get("api/MailMerge/GetMergeDocument", {
            params: {
                CustomerId: request.custId,
                MergeDocTemplateId: request.mergeDocTemplateId,
                PolicyId: request.policyId || undefined,
                Language: request.languageId,
                PrintNow: request.printNow,
                IndexKey1: request.indexkey1,
                IndexKey2: request.indexkey2,
                UserId: request.userId,
                Attributes: request.attributes,
                DocumentTypeId: request.documentTypeId,
                MergeDocID: request.mergeDocID,
                SavePrintedDocument: request.savePrintedDocument,
                InputFields: request.inputFields
            },
            responseType: 'blob',  // This tells Axios to treat the response as a Blob
        });

        return res.data;
    }

    public getInputFields = async (mergeDocTemplateId: string) => {
        client.setBaseURLForService(mailMergeBaseKey)
        const res: AxiosResponse<any[]> = await client.get("/api/MailMerge/GetInputFields?mergeDocTemplateId="+ mergeDocTemplateId)
        return res.data;
    }
}

export default MailMergeAPI;